export const cardView = {
  name: "card-view" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 4a.9.9 0 0 1 .9-.9h16a.9.9 0 0 1 .9.9v6a.9.9 0 0 1-.9.9H4a.9.9 0 0 1-.9-.9V4Zm1.8.9v4.2h3.2V4.9H4.9Zm5 0v4.2h9.2V4.9H9.9ZM3.1 14a.9.9 0 0 1 .9-.9h16a.9.9 0 0 1 .9.9v6a.9.9 0 0 1-.9.9H4a.9.9 0 0 1-.9-.9v-6Zm1.8.9v4.2h3.2v-4.2H4.9Zm5 0v4.2h9.2v-4.2H9.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["card-view"],
  category: "utility" as const,
};
